var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JadeGroupHeader", [_vm._v(_vm._s(_vm.$t("title")))]),
      _c("JadeListItem", {
        attrs: {
          label: _vm.$t("provider-name"),
          trailing: _vm.data.antifraud,
          compact: "",
        },
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("score"), trailing: _vm.data.score },
      }),
      _c("JadeDivider"),
      _c(
        "div",
        { staticClass: "flex justify-between px-5 py-3" },
        [
          _c("JadeText", [_vm._v(_vm._s(_vm.$t("status")))]),
          _c("JadeTag", { attrs: { variant: _vm.data.status.variant } }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t(`charge.filter.${_vm.data.status.text}`)) +
                " "
            ),
          ]),
        ],
        1
      ),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("return-code"), trailing: _vm.data.returnCode },
      }),
      _c("JadeDivider"),
      _vm.reprovedMessage
        ? _c(
            "div",
            { staticClass: "flex flex-col gap-2 px-5 py-5" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    color: "negative",
                    variant: "text-medium",
                    weight: "semibold",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("return-message-default")) + " ")]
              ),
              _c(
                "JadeText",
                { attrs: { color: "negative", variant: "text-medium" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("return-message")) + " "),
                  _c(
                    "JadeText",
                    {
                      attrs: {
                        as: "a",
                        variant: "hyperlink-medium",
                        color: "negative",
                        alt: "Help Center",
                        href: _vm.$sanitize(_vm.computedHelpLink),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("return-message-link")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("JadeDivider", { attrs: { size: "medium" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }